import axios from "axios";

export default axios.create({
    //baseURL: "http://localhost:4500",
    baseURL: "https://oracly-api.app.svppb.com",
    headers: {
        "Content-type": "application/json"
    }
});
